import { render, staticRenderFns } from "./ProjectCardPosts.vue?vue&type=template&id=bb64396c&scoped=true"
import script from "./ProjectCardPosts.vue?vue&type=script&lang=js"
export * from "./ProjectCardPosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb64396c",
  null
  
)

export default component.exports